<div class="timeline-holder right">
    <div class="content">
      <h2>Jan - 2019</h2>
      <p>Sunriseprofessor is renamed to Boldungu with a mission to provide <b>bold</b> learning with fun like music from <a href="https://en.wikipedia.org/wiki/Adungu">adungu</a></p>
    </div>
  </div>
